import { ErrorDto } from './error-dto';
export class FieldErrorDto {
  fieldName: string;
  fielsErrors: ErrorDto[];
}
